



































import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class App extends Vue {
  @Prop({ default: () => [] }) public cols;
  @Prop({ default: () => [] }) public data;
  goWebSite(url) {
    // 延迟跳转，给时间做bi上报
    setTimeout(() => {
      window.location.href = url;
    }, 300);
  }
}
